import React from 'react';

const DokanPageTitle = ({ children }) => (
    <h3 className="text-primary text-xl font-bold">{children}</h3>
);

export default DokanPageTitle;
